import './zod-config';
// The brand typeface, served from this origin (the CSP loads nothing from elsewhere).
import '@fontsource-variable/montserrat/wght.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';

const container = document.getElementById('root');
if (container === null) throw new Error('#root element missing');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
